import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles({
  container: {
    height: ''
  },
  table: {
    tableLayout: 'auto',
  },
  error: {
    color: red.A400,
  },
});

export default useStyles;